module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r9r7r4n-cf4d8fbe07feb3049d73a6f1e49f3bc9.svg";